<template>
  <div>
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6 row">
            <div class="col-sm-2">
            <h1 class="m-0 text-dark" style="">儀表板</h1>
            </div>
            <div class="col-sm-4">
            <el-button  ref="btn"  type="success" style="width:75px" @click="refreshData()" :disabled="forbidden">刷新</el-button>
            </div>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right"></ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <!-- 昨日新增 -->
        <h5 class="mb-2">昨日新增</h5>
        <div class="row">
          <section class="col-12">
            <div class="row">
              <section class="col-xl-9 col-12">
                <div class="row">
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-folder-plus"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">相簿</span>
                        <span class="info-box-number">{{
                          yesterdayData.album
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-images"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">相片</span>
                        <span class="info-box-number">{{
                          yesterdayData.photo
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-comments"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">社交動態</span>
                        <span class="info-box-number">{{
                          yesterdayData.moiveCommunity
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-comment-dots"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">留言</span>
                        <span class="info-box-number">{{
                          yesterdayData.message
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-running"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">賽事</span>
                        <span class="info-box-number">{{
                          yesterdayData.activity
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-newspaper"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">文章</span>
                        <span class="info-box-number">{{
                          yesterdayData.newArticle
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-play-circle"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">影片</span>
                        <span class="info-box-number">{{
                          yesterdayData.moiveCommunity
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-user-plus"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">新會員</span>
                        <span class="info-box-number">{{
                          yesterdayData.member
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-download"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">相片下載量</span>
                        <span class="info-box-number">{{
                          yesterdayData.download
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-cloud-upload-alt"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">社區使用量</span>
                        <span class="info-box-number">{{
                          yesterdayData.moiveCommunityDiskF
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-cloud-upload-alt"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">SOONNET TV</span>
                        <span class="info-box-number">{{
                          yesterdayData.videoDiskF
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-6">
                    <div class="info-box">
                      <span class="info-box-icon bg-info"
                        ><i class="fa fa-cloud-upload-alt"></i
                      ></span>
                      <div class="info-box-content">
                        <span class="info-box-text">人臉/文字搜索量</span>
                        <span class="info-box-number"
                          >{{ yesterdayData.apI_renlian }}/{{
                            yesterdayData.apI_wenzi
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section class="col-xl-3 col-12">
                <!-- 目前在線人數 -->
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">目前在線人數</h3>
                  </div>
                  <!-- /.card-header -->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-8">
                        <div class="chart-responsive">
                          <div
                            ref="pieChart"
                            id="pieChart"
                            style="height: 150px"
                          ></div>
                        </div>
                        <!-- ./chart-responsive -->
                      </div>
                      <!-- /.col -->
                      <div class="col-md-4">
                        <ul class="chart-legend clearfix">
                          <li>在線人數: {{ onlineUser.userCount }}</li>
                          <li>
                            <i class="far fa-circle text-dashbaord-blue"></i>
                            會員: {{ onlineUser.IsUser }}
                          </li>
                          <li>
                            <i class="far fa-circle text-dashboard-grey"></i>
                            非會員: {{ onlineUser.notUser }}
                          </li>
                        </ul>
                      </div>
                      <!-- /.col -->
                    </div>
                    <!-- /.row -->
                  </div>
                  <!-- /.card-body -->
                </div>
              </section>
            </div>
          </section>
        </div>

        <!-- 網站統計 -->
        <h5 class="mb-2">網站統計</h5>
        <div class="row">
          <section class="col-xl-7 col-12">
            <!-- 訪問量 -->
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="fas fa-users mr-1"></i> 訪問量
                </h3>
                <div class="card-tools">
                  <ul class="nav nav-pills ml-auto">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        href="javascript:"
                        @click="charts1Type = 0"
                        data-toggle="tab"
                        >日</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="javascript:"
                        @click="charts1Type = 1"
                        data-toggle="tab"
                        >週</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="javascript:"
                        @click="charts1Type = 2"
                        data-toggle="tab"
                        >月</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="javascript:"
                        @click="charts1Type = 3"
                        data-toggle="tab"
                        >年</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <div class="tab-content p-0">
                  <div
                    class="chart"
                    id="visitor-chart"
                    style="position: relative; height: 300px"
                  >
                    <div id="visitor-chart-canvas" style="height: 300px"></div>
                  </div>
                </div>
              </div>
              <!-- /.card-body -->
            </div>

            <!-- 裝置訪問量 -->
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="fas fa-desktop mr-1"></i> 裝置訪問量
                </h3>
                <div class="card-tools">
                  <ul class="nav nav-pills ml-auto">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        href="javascript:"
                        @click="charts2Type = 0"
                        data-toggle="tab"
                        >日</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="javascript:"
                        @click="charts2Type = 1"
                        data-toggle="tab"
                        >週</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="javascript:"
                        @click="charts2Type = 2"
                        data-toggle="tab"
                        >月</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="javascript:"
                        @click="charts2Type = 3"
                        data-toggle="tab"
                        >年</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body">
                <div class="position-relative mb-4">
                  <div id="device-chart" style="height: 300px"></div>
                </div>
              </div>
            </div>
            <!-- /.card -->
          </section>
          <section class="col-xl-5 col-12">
            <!-- 最近上傳項目 -->
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="fas fa-cloud-upload-alt mr-1"></i> 最近上傳項目
                </h3>
                <div class="card-tools">
                  <ul class="nav nav-pills ml-auto">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        href="#visitor-chart"
                        data-toggle="tab"
                        >進行中</a
                      >
                    </li>
                    <!-- <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#visitor-chart"
                        data-toggle="tab"
                        >已中斷</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#visitor-chart"
                        data-toggle="tab"
                        >已完成</a
                      >
                    </li> -->
                  </ul>
                </div>
              </div>
              <div
                class="card-body table-responsive p-0"
                style="font-size: 12px"
              >
                <div
                  style="
                    display: flex;
                    background-color: #f5f5f5;
                    justify-content: space-evenly;
                    align-items: center;
                    text-align: center;
                    font-weight: 900;
                  "
                >
                  <div style="flex: 1; max-width: 80px">#</div>
                  <div style="flex: 1">會員</div>
                  <div style="flex: 1">數量</div>
                  <div style="flex: 1">開始時間</div>
                  <div style="flex: 1">速率</div>
                  <div style="flex: 1">已進行</div>
                </div>

                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  v-for="(item, ix) in uploadList"
                  :key="ix"
                >
                  <div style="width: 80px; text-align: center">
                    {{ ++ix }}
                  </div>
                  <div style="flex: 1; display: flex; flex-direction: column">
                    <div
                      style="
                        flex: 1;
                        display: flex;
                        justify-content: space-evenly;
                        text-align: center;
                        margin: 10px 0px 0px 0px;
                      "
                    >
                      <div style="flex: 1">{{ item.userName }}</div>
                      <div style="flex: 1">
                        {{ item.number }}張 ({{ item.size }})
                      </div>
                      <div style="flex: 1">{{ item.date }}</div>
                      <div style="flex: 1">{{ item.rate }}</div>
                      <div style="flex: 1">
                        <i
                          v-if="item.isMobile"
                          class="fas fa-mobile-alt"
                          title="手機上載"
                        ></i>
                      </div>
                    </div>
                    <div style="padding: 5px; display: flex">
                      <div style="flex: 1">
                        <span class="progress">
                          <span
                            class="progress-bar bg-green"
                            :style="{
                              width: item.ps + '%',
                            }"
                          >
                            {{ item.ps }}%
                          </span>
                        </span>
                      </div>
                      <div style="min-width: 80px; text-align: center">
                        {{ item.time }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 相片上傳 -->
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="fas fa-images mr-1"></i> 相片上傳
                </h3>
                <div class="card-tools">
                  <ul class="nav nav-pills ml-auto">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        href="javascript:"
                        @click="charts4Type = 0"
                        data-toggle="tab"
                        >日</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="javascript:"
                        @click="charts4Type = 1"
                        data-toggle="tab"
                        >週</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="javascript:"
                        @click="charts4Type = 2"
                        data-toggle="tab"
                        >月</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="javascript:"
                        @click="charts4Type = 3"
                        data-toggle="tab"
                        >年</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <div class="tab-content p-0">
                  <div
                    class="chart"
                    id="upload-photo-chart"
                    style="position: relative; height: 300px"
                  >
                    <div
                      id="upload-photo-chart-canvas"
                      style="height: 300px"
                    ></div>
                  </div>
                </div>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                <div class="row">
                  <div class="col-6 border-right">
                    <div class="description-block">
                      <span class="description-percentage text-success"></span>
                      <h5 class="description-header">
                        {{ charts4DataCount2 }}
                      </h5>
                      <span class="description-text">相簿</span>
                    </div>
                  </div>
                  <div class="col-6 border-right">
                    <div class="description-block">
                      <span class="description-percentage text-warning"></span>
                      <h5 class="description-header">
                        {{ charts4DataCount1 }}
                      </h5>
                      <span class="description-text">相片</span>
                    </div>
                  </div>
                </div>
                <!-- /.row -->
              </div>
              <!-- /.card-footer -->
            </div>

            <!--  新加入會員 -->
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="fas fa-user-plus mr-1"></i> 在線會員
                </h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body p-0">
                <ul class="users-list clearfix">
                  <li v-for="(item,idx) in userOnlineList" style="width: 12.5%" :key="idx">
                    <img :src="item.userlogoImage" style="width: 48px" />
                    <a class="users-list-name" href="javascript:">{{
                      item.displayName
                    }}</a>
                    <span class="users-list-location">{{ item.location }}</span>
                  </li>
                </ul>
                <!-- /.users-list -->
              </div>
              <!-- /.card-body -->
              <!-- <div class="card-footer text-center">
                <a href="javascript:">查看所有會員</a>
              </div> -->
              <!-- /.card-footer -->
            </div>
          </section>
        </div>

        <!-- 伺服器空間 -->
        <h5 class="mb-2" v-if="computerData">伺服器空間</h5>
        <div class="row" v-if="computerData">
          <div
            class="col-lg-3 col-md-6 col-12"
            v-for="(item, ix) in computerData"
            :key="ix"
          >
            <div class="info-box">
              <span class="info-box-icon"><i class="fa fa-server"></i></span>
              <div class="info-box-content">
                <span class="info-box-text">{{ item.name }}</span>
                <div v-for="(dd,idx) in item.data" style="margin-top: 10px" :key="idx">
                  <span
                    class="info-box-text"
                    style="font-weight: 600; white-space: initial"
                  >
                    {{ dd.partitionName }} 剩餘 {{ dd.freeSpace }} GB，共
                    {{ dd.sumSpace }} GB ({{
                      Math.round((dd.freeSpace / dd.sumSpace) * 100)
                    }}%)
                  </span>
                  <div class="progress">
                    <div
                      class="progress-bar bg-red"
                      :style="{
                        width: `${Math.round(
                          100 - (dd.freeSpace / dd.sumSpace) * 100
                        )}%`,
                        'background-color':
                          (dd.freeSpace / dd.sumSpace) * 100 <= 30
                            ? 'red !important'
                            : '#009688 !important',
                      }"
                    ></div>
                  </div>
                </div>
                <!--                 <span class="info-box-number">{{item.}}</span>
                <div class="progress">
                  <div class="progress-bar bg-red" style="width: 99%"></div>
                </div>
                <span class="progress-description">
                  剩餘 154 GB，共 19.5 TB (99%)
                </span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>

<script>
import * as echarts from "echarts";
import socketUtil from "@/assets/js/websocketTools";
import { nanoid } from "nanoid";
export default {
  data() {
    return {
      uploadList: [],
      userOnlineList: [],
      yesterdayData: {},
      charts1: null,
      charts2: null,
      charts1Type: 0,
      charts2Type: 0,
      charts4Type: 0,
      charts4Data: null,
      charts4DataCount1: 0,
      charts4DataCount2: 0,
      charts3: null,
      charts1Data: null,
      computerData: null,
      onlineUser: {
        userCount: 0,
        IsUser: 0,
        notUser: 0,
        userList: [],
      },
      forbidden : false,
      timer : null,
      timer_ : null,
      times : 60,
    };
  },
  created() {
    this._websocketinit();
    this.timer_ = setInterval(this._websocketinit,1000 * 5);
    this.getVNewYesterdayAdded();
    this.getYestDay();
    this.getComputerService();
    this.getUploadPhotoCount();
    // this.websocketInit();

     
  },
  destroyed(){
    clearInterval(this.timer_);
  },
  watch: {
    charts1Type(newV, oldV) {
      if (newV !== oldV) {
        this.setChart2();
      }
    },
    charts2Type(newV, oldV) {
      if (newV !== oldV) {
        this.setChart3();
      }
    },
    charts4Type(newV, oldV) {
      if (newV !== oldV) {
        this.setChart4();
      }
    },
  },
  methods: {
    /**
     * @description : 后台数据刷新
     * 
     * @date : 2023-06-26 09:46:11
    */
    async refreshData(){
      const { data:res } = await this.$api.common.RetryHangfire({});
      res.success && this.refreshTimeData();
    },
    refreshTimeData () {
      let that = this;
      that.times = 60;
      that.forbidden = true;
      this.timer = setInterval(() => {
        that.$refs.btn.$el.innerText = `${that.times}s`;
        if (that.times == 0) {
          clearInterval(that.timer);
          that.getVNewYesterdayAdded();
          that.getYestDay();
          that.getComputerService();
          that.getUploadPhotoCount();
          that.$refs.btn.$el.innerText = `刷新`;
          that.forbidden = false;
        }
        that.times--;
      }, 1000);
    },
    getUploadPhotoCount() {
      this.$api.permissionApi.getUploadPhotoCount().then((res) => {
        this.charts4Data = res.data.result;
        this.setChart4();
      });
    },
    getComputerService() {
      this.$api.permissionApi.getComputerService().then((res) => {
        let cmpData = [];
        if(res.data.result){
          Object.keys(res.data.result).forEach((item) => {
            let a = {
              name: item,
              data: res.data.result[item],
            };
            cmpData.push(a);
          });
        }

        this.computerData = cmpData;
      });
    },
    getVNewYesterdayAdded() {
      this.$api.permissionApi.getVNewYesterdayAdded().then((rst) => {
        if (rst.data.success) {
          if (rst.data.result) {
            this.yesterdayData = rst.data.result;
          }
        }
      });
    },
    getYestDay() {
      this.$api.permissionApi.getYestDay().then((rst) => {
        this.charts1Data = rst.data.result;
        this.setChart2();
        this.setChart3();
      });
    },
    websocketInit() {
      socketUtil.initWebsocket(2, this.websocketMessage, this.websocketOpen);
    },
    websocketMessage(e) {
      socketUtil.websocketonmessage(e);

      if (e.data) {
        const data = JSON.parse(e.data);
        if (data.MessageType === "userOnline") {
          this.onlineUser = JSON.parse(data.Content);
          this.setChart1();
          this.userOnlineList = this.onlineUser.userList;
        } else if (data.MessageType === "uploadImage") {
          let lst = JSON.parse(data.Content);
          lst.forEach((item) => {
            let v = "M";
            if (item.size > 0) {
              item.size = (item.size / 1024).toFixed(2);
            }
            if (item.size >= 1024) {
              item.size = (item.size / 1024).toFixed(2);
              v = "G";
            }
            if (item.size >= 1024) {
              item.size = (item.size / 1024).toFixed(2);
              v = "T";
            }
            item.size = item.size + v;
          });
          this.uploadList = lst;
          this.$forceUpdate();
          /* if (this.uploadList.filter((item) => item.ps >= 100).length > 0) {
            setTimeout(() => {
              this.uploadList = this.uploadList.filter((item) => item.ps < 100);
            }, 1000);
            this.$forceUpdate();
          } */
          // console.log(this.uploadList);
        }
      }
    },

    async _websocketinit(){

      const { data:result } = await this.$api.common.GetredisCache();
      // const userOnline = JSON.parse(result.userOnline);
      const uploadImage = result.result.uploadImage;
      this.onlineUser = JSON.parse(result.result.userOnline);
      this.setChart1();
      this.userOnlineList = this.onlineUser.userList;

      uploadImage.forEach((item) => {
            let v = "M";
            if (item.size > 0) {
              item.size = (item.size / 1024).toFixed(2);
            }
            if (item.size >= 1024) {
              item.size = (item.size / 1024).toFixed(2);
              v = "G";
            }
            if (item.size >= 1024) {
              item.size = (item.size / 1024).toFixed(2);
              v = "T";
            }
            item.size = item.size + v;
          });
          this.uploadList = uploadImage;
          this.$forceUpdate();
    },
    websocketOpen() {
      // socketUtil.websocketonopen();
      socketUtil.websocketsend({
        MessageType: "userOnline",
      });
    },
    setChart1() {
      const id = "pieChart";
      if (!this.charts1) {
        this.charts1 = echarts.init(document.getElementById(id));
      }
      let a1 = this.onlineUser.IsUser;
      let a2 = this.onlineUser.notUser;
      this.charts1.setOption({
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "80%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: a1, name: "會員" },
              { value: a2, name: "非會員" },
            ],
          },
        ],
      });
    },
    setChart2() {
      const id = "visitor-chart-canvas";
      if (!this.charts2) {
        this.charts2 = echarts.init(document.getElementById(id));
      }
      let xa = [];
      let y1 = [];
      let y2 = [];
      if (this.charts1Data) {
        let forData = null;
        if (this.charts1Type === 0) {
          forData = this.charts1Data.day;
        } else if (this.charts1Type === 1) {
          forData = this.charts1Data.week;
        } else if (this.charts1Type === 2) {
          forData = this.charts1Data.month;
        } else if (this.charts1Type === 3) {
          forData = this.charts1Data.year;
        }
        if (forData) {
          forData.forEach((element) => {
            xa.push(element.day);
            y1.push(element.sgL_On_ATrueRequest);
            y2.push(element.sgL_On_ARequest);
          });
        }
        xa = [...new Set(xa)];
      }
      this.charts2.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["訪問量", "瀏覽量"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: xa,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "訪問量",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: y1,
          },
          {
            name: "瀏覽量",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: y2,
          },
        ],
      });
    },
    setChart3() {
      const id = "device-chart";
      if (!this.charts3) {
        this.charts3 = echarts.init(document.getElementById(id));
      }
      let xa = [];
      let y1 = [];
      let y2 = [];
      let maxY = 0;
      if (this.charts1Data) {
        let forData = null;
        if (this.charts2Type === 0) {
          forData = this.charts1Data.day;
        } else if (this.charts2Type === 1) {
          forData = this.charts1Data.week;
        } else if (this.charts2Type === 2) {
          forData = this.charts1Data.month;
        } else if (this.charts2Type === 3) {
          forData = this.charts1Data.year;
        }
        if (forData) {
          forData.forEach((element) => {
            xa.push(element.day);
            y1.push(element.sgL_On_mobileRequest);
            y2.push(element.sgL_On_PCRequest);
            if (element.sgL_On_PCRequest > maxY) {
              maxY = element.sgL_On_PCRequest;
            }
            if (element.sgL_On_mobileRequest > maxY) {
              maxY = element.sgL_On_mobileRequest;
            }
          });
        }
        xa = [...new Set(xa)];
      }
      this.charts3.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        legend: {
          data: ["桌面電腦", "流動裝置"],
        },
        xAxis: [
          {
            type: "category",
            data: xa,
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max: maxY +  Math.floor(maxY / 10),
            interval: Math.floor(maxY / 10) ,
            precision: 0,
            // minInterval: 1,
            /*             axisLabel: {
              formatter: "{value} $",
            }, */
          },
        ],
        series: [
          {
            name: "桌面電腦",
            type: "bar",
            data: y2,
          },
          {
            name: "流動裝置",
            type: "bar",
            data: y1,
          },
        ],
      });
    },
    setChart4() {
      if (!this.charts4) {
        this.charts4 = echarts.init(
          document.getElementById("upload-photo-chart-canvas")
        );
      }
      let forData = null;
      if (this.charts4Data) {
        if (this.charts4Type === 0) {
          forData = this.charts4Data.day;
        } else if (this.charts4Type === 1) {
          forData = this.charts4Data.week;
        } else if (this.charts4Type === 2) {
          forData = this.charts4Data.month;
        } else if (this.charts4Type === 3) {
          forData = this.charts4Data.year;
        }
      }
      let x = [];
      let y = [];
      this.charts4DataCount1 = 0;
      this.charts4DataCount2 = 0;
      if (forData) {
        forData.forEach((item) => {
          x.push(item.day);
          y.push(item.sgL_PG_CPhotoQuantity);
          this.charts4DataCount1 += item.sgL_PG_CPhotoQuantity;
          this.charts4DataCount2 += item.sgL_PG_CPhoto;
        });
      }
      this.charts4.setOption({
        color: ["#80FFA5"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        //   formatter: function(params) {
        //     // params 是包含当前鼠标所在位置所有数据信息的对象数组
        //     return params.map(item => {
        //         // 取出seriesName和value并做处理
        //         var value = parseInt(item.value);
        //         return `${item.seriesName}: ${value}`;
        //     }).join('<br/>');
        // }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: x,
          },
        ],
        yAxis: [
          {
            type: "value",
            precision: 0,
            axisLabel: {
            // formatter: function (value, index) {
            //     return Math.round(value);
            // }810
        }
          },
        ],
        series: [
          {
            name: "新增相片",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(60,141,188,0.9)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: y,
          },
        ],
      });
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.setChart1();
      this.setChart2();
      this.setChart3();
      this.setChart4();
    });
  },
};
</script>

<style scoped>
.b-upload-task {
  font-size: 0.75rem;
}

.b-upload-task.table-striped tbody tr:nth-of-type(odd) {
  background: none;
}

.b-upload-task.table thead > tr > th:first-of-type,
.b-upload-task.table thead > tr > td:first-of-type,
.b-upload-task.table tbody > tr > th:first-of-type,
.b-upload-task.table tbody > tr > td:first-of-type {
  padding-left: 1rem !important;
}

.b-upload-task.table thead > tr > th:last-of-type,
.b-upload-task.table thead > tr > td:last-of-type,
.b-upload-task.table tbody > tr > th:last-of-type,
.b-upload-task.table tbody > tr > td:last-of-type {
  padding-right: 0.5rem !important;
}

.b-upload-task.table thead > tr:nth-of-type(even) > th:first-of-type,
.b-upload-task.table thead > tr:nth-of-type(even) > td:first-of-type,
.b-upload-task.table tbody > tr:nth-of-type(even) > th:first-of-type,
.b-upload-task.table tbody > tr:nth-of-type(even) > td:first-of-type {
  padding-left: 0.25rem !important;
}

.b-upload-task.table tr:nth-of-type(odd) td {
  padding-bottom: 0;
}

.b-upload-task.table tr:nth-of-type(even) td {
  border-top: 0;
  padding-top: 0;
}

.b-upload-task th,
.b-upload-task tr,
.b-upload-task td {
  padding: 0.25rem;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.b-upload-task .progress {
  height: 0.75rem;
  border-radius: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminManage/index.vue